const isStrEqCaseInsensitive = (a: any, b: any): boolean =>
  typeof a === 'string' &&
  typeof b === 'string' &&
  a.toLowerCase() === b.toLowerCase()

export default isStrEqCaseInsensitive
